export default "__VITE_ASSET__C95J$Ed9__"